
import React from 'react';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-drop-line',
      title: 'Instalatérské práce',
      description: 'Kompletní instalace vodovodních systémů, opravy potrubí, výměna baterií a sanitární techniky.',
      features: ['Instalace vodovodů', 'Opravy potrubí', 'Výměna baterií', 'Sanitární technika']
    },
    {
      icon: 'ri-fire-line',
      title: 'Topenářské práce',
      description: 'Instalace a servis topných systémů, kotlů, radiátorů a podlahového vytápění.',
      features: ['Instalace kotlů', 'Servis topení', 'Radiátory', 'Podlahové vytápění']
    },
    {
      icon: 'ri-gas-station-line',
      title: 'Plynové instalace',
      description: 'Bezpečné instalace plynových rozvodů a připojení plynových spotřebičů.',
      features: ['Plynové rozvody', 'Připojení spotřebičů', 'Revize plynu', 'Bezpečnostní kontroly']
    },
    {
      icon: 'ri-water-percent-line',
      title: 'Kanalizace',
      description: 'Instalace a opravy kanalizačních systémů, čištění odpadů a údržba.',
      features: ['Instalace kanalizace', 'Čištění odpadů', 'Opravy potrubí', 'Údržba systémů']
    },
    {
      icon: 'ri-24-hours-line',
      title: 'Havarijní služba',
      description: 'Rychlá pomoc při haváriích 24 hodin denně, 7 dní v týdnu.',
      features: ['Dostupnost 24/7', 'Rychlý zásah', 'Nouzové opravy', 'Okamžitá pomoc']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Servis a údržba',
      description: 'Pravidelný servis a údržba instalatérských a topných systémů.',
      features: ['Pravidelné kontroly', 'Preventivní údržba', 'Servisní smlouvy', 'Poradenství']
    }
  ];

  return (
    <section id="sluzby" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>Naše služby</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Poskytujeme kompletní instalatérské a topenářské služby v Mladé Boleslavi a okolí. 
            Ke každému zákazníkovi přistupujeme individuálně s důrazem na kvalitu a spolehlivost.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-blue-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="bg-blue-600 text-white rounded-xl p-8">
            <h3 className="text-2xl font-bold mb-4">Potřebujete rychlou pomoc?</h3>
            <p className="text-blue-100 mb-6">Havarijní služba dostupná 24 hodin denně, 7 dní v týdnu</p>
            <a href="tel:+420720520035" className="inline-flex items-center bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
              <i className="ri-phone-line mr-2"></i>
              720 520 035
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
